export enum CMMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_CONTAINER = 'SET_CONTAINER'
}
